import alert from './alert';
import confirm from './confirm';
import dateFriendly from './date_friendly';
import debounce from "./debounce";
import getAndroidFile from './get_android_file';
import getAndroidFileBlob from './get_android_file_blob';
import goBack from './go_back';
import isPremium from './is_premium';
import linebreaksbr from './linebreaksbr';
import logUserOut from './log_user_out';
import logUserOutWeb from './log_user_out_web';
import smoothScroll from './smooth_scroll';
import upgradeNotice from './upgrade_notice';
import {encrypt, decrypt, hexDigest} from './crypto';
import {getItem, setItem} from './nativestorage';
import getFileContentAsBase64 from './get_file_contents_as_base64';
import api from './api';
import postAchievement from './post_achievement';

export default {
  alert,
  confirm,
  dateFriendly,
  debounce,
  getAndroidFile,
  getAndroidFileBlob,
  getFileContentAsBase64,
  goBack,
  isPremium,
  linebreaksbr,
  logUserOut,
  logUserOutWeb,
  smoothScroll,
  upgradeNotice,
  encrypt,
  decrypt,
  hexDigest,
  setItem,
  getItem,
  api,
  postAchievement,
};
